/* eslint-disable import/prefer-default-export */
import Immutable from 'seamless-immutable';
import _ from 'lodash';

import {
  getForm,
  createValidateObject,
  storeRecoveryFieldValues,
  storeSetFieldValue,
  storeSetFieldsErrors
} from '../../../../../utils/reducerHalpers/formFields';
import * as validateTypes from '../../../../../utils/reducerHalpers/validateTypes';
import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../utils/reducerHalpers/requestState';

const INIT_STATE = 'INIT_STATE';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const SEND_FORM = 'SEND_FORM';
const LOAD_FORM_DATA = 'LOAD_FORM_DATA';
const RECOVERY_FIELDS = 'RECOVERY_FIELDS';
const SET_ERRORS = 'SET_ERRORS';
const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';
const SET_SEND_FORM_RESPONSE = 'SET_SEND_FORM_RESPONSE';

const CHANGE_FIELD_USERNAME = 'CHANGE_FIELD_USERNAME';
const CHANGE_FIELD_EMAIL = 'CHANGE_FIELD_EMAIL';
const CHANGE_FIELD_PHONE_NUMBER = 'CHANGE_FIELD_PHONE_NUMBER';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) => _.get(state, reducerName);

const createReducer = name => {
  function stateDefault() {
    return {
      ...createRequestState(),
      fields: {
        username: {
          title: 'Имя пользователя',
          inValue: null,
          value: null,
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        },
        email: {
          title: 'Электронная почта',
          inValue: null,
          value: null,
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        },
        phone_number: {
          title: 'Номер телефона',
          inValue: null,
          value: null,
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        }
      },
      errors: [],
      resultObject: {}
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(name, REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(name, LOAD_FORM_DATA):
        return setRequestStateInProgress(state).merge({
          updateObjectId: action.payload
        });
      case createActionName(name, RECOVERY_FIELDS):
        return storeRecoveryFieldValues(state, action.payload);
      case createActionName(name, SEND_FORM):
        return setRequestStateInProgress(state);
      case createActionName(name, SET_ERRORS):
        return storeSetFieldsErrors(state, action.payload);
      case createActionName(name, CLEAR_ALL_ERRORS):
        return state;
      case createActionName(name, SET_SEND_FORM_RESPONSE):
        return state.merge({
          resultObject: action.payload
        });

      case createActionName(name, CHANGE_FIELD_USERNAME): {
        return storeSetFieldValue(state, 'username', action.payload);
      }

      case createActionName(name, CHANGE_FIELD_EMAIL): {
        return storeSetFieldValue(state, 'email', action.payload);
      }

      case createActionName(name, CHANGE_FIELD_PHONE_NUMBER): {
        return storeSetFieldValue(state, 'phone_number', action.payload);
      }

      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS
export const initState = reducerName => ({
  type: createActionName(reducerName, INIT_STATE)
});
export const requestFinished = (reducerName, codeResponse, hasSuccess) => ({
  type: createActionName(reducerName, REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const loadFormData = (reducerName, payload) => ({
  type: createActionName(reducerName, LOAD_FORM_DATA),
  payload
});
export const recoveryFields = (reducerName, payload) => ({
  type: createActionName(reducerName, RECOVERY_FIELDS),
  payload
});
export const sendForm = (reducerName, payload) => ({
  type: createActionName(reducerName, SEND_FORM),
  payload
});
export const setErrors = (reducerName, payload) => ({
  type: createActionName(reducerName, SET_ERRORS),
  payload
});
export const clearAllErrors = (reducerName, payload) => ({
  type: createActionName(reducerName, CLEAR_ALL_ERRORS),
  payload
});
export const setSendFormResponse = (reducerName, payload) => ({
  type: createActionName(reducerName, SET_SEND_FORM_RESPONSE),
  payload
});
// FIELDS
export const changeFieldUserName = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_USERNAME),
  payload
});
export const changeFieldEmail = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_EMAIL),
  payload
});
export const changeFieldPhoneNumber = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_PHONE_NUMBER),
  payload
});

// SELECTORS
export const selectState = (state, reducerName) => getState(state, reducerName);
export const selectRequestState = (state, reducerName) =>
  _.get(getState(state, reducerName), 'requestState');

export const selectFormBody = (state, reducerName) =>
  getForm(getState(state, reducerName));
export const selectFieldUsername = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.username');
export const selectFieldEmail = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.email');
export const selectFieldPhoneNumber = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.phone_number');
export const selectAllErrors = (state, reducerName) =>
  _.get(getState(state, reducerName), 'errors');
export const selectResultObject = (state, reducerName) =>
  _.get(getState(state, reducerName), 'resultObject');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/common/reducers/forms/profileForm.js